import { create } from 'zustand';

import type { ChatFileDTO } from '@/api/sessionApi';

export interface PendingChatCommand {
  commandId: string;
  botId: string;
  text: string;
  model: string;
  mcpConfigId: number | null;
  thinkingEnabled: boolean;
  skillIds: string[];
  selectedFiles: ChatFileDTO[];
  createdAt: number;
}

interface PendingChatCommandStore {
  commands: Record<string, PendingChatCommand>;
  version: number;
  writeCommand: (command: Omit<PendingChatCommand, 'commandId' | 'createdAt'>) => void;
  consumeCommand: (botId: string, commandId: string) => PendingChatCommand | null;
  peekCommand: (botId?: string) => PendingChatCommand | null;
}

export const usePendingChatCommandStore = create<PendingChatCommandStore>(
  (set, get) => ({
    commands: {},
    version: 0,
    writeCommand: command => {
      const commandId = `${command.botId}_${Date.now()}_${Math.random()
        .toString(36)
        .slice(2)}`;
      set(state => ({
        commands: {
          ...state.commands,
          [command.botId]: {
            ...command,
            commandId,
            createdAt: Date.now(),
          },
        },
        version: state.version + 1,
      }));
    },
    consumeCommand: (botId, commandId) => {
      const command = get().commands[botId];
      if (!command || command.commandId !== commandId) return null;
      set(state => {
        const { [botId]: _, ...rest } = state.commands;
        return {
          commands: rest,
          version: state.version + 1,
        };
      });
      return command;
    },
    peekCommand: botId => {
      if (!botId) return null;
      return get().commands[botId] ?? null;
    },
  })
);
